__turbopack_context__.v({
  "bannerImageWrapper": "styles-module-scss-module__pvoEka__bannerImageWrapper",
  "content": "styles-module-scss-module__pvoEka__content",
  "ctaBtn": "styles-module-scss-module__pvoEka__ctaBtn",
  "image": "styles-module-scss-module__pvoEka__image",
  "leadershipContent": "styles-module-scss-module__pvoEka__leadershipContent",
  "maxWidth85": "styles-module-scss-module__pvoEka__maxWidth85",
  "root": "styles-module-scss-module__pvoEka__root",
  "title": "styles-module-scss-module__pvoEka__title",
});
